import React, { useMemo } from 'react'
import { t } from 'i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faSquarePen,
  faTrashAlt,
  faEye,
  faCheck,
  faTimes,
} from '@fortawesome/free-solid-svg-icons'
import { ReactComponent as CatalogIcon } from 'Assets/Images/Generals/catalog_icon.svg'

const isActiveStatus = value =>
  value === true ||
  value === 1 ||
  value === '1' ||
  value?.toString?.().toLowerCase() === 'true'

function useColumnSearchQuickList({
  onViewProducts,
  onEdit,
  onDelete,
  onGenerateCatalog,
  pagination,
}) {
  return useMemo(
    () => [
      {
        Header: '#',
        accessor: 'row',
        width: 40,
        Cell: ({ row }) =>
          (pagination.currentPage - 1) * pagination.pageSize + row.index + 1,
      },
      {
        Header: t('QUICK_LIST_SETTINGS.LIST.NAME'),
        accessor: 'Name',
        Cell: ({ value }) => value || '—',
      },
      {
        Header: t('QUICK_LIST_SETTINGS.LIST.DESCRIPTION'),
        accessor: 'Description',
        Cell: ({ value }) => value || '—',
      },
      {
        Header: t('QUICK_LIST_SETTINGS.LIST.PRODUCTS'),
        accessor: 'ProductListCount',
        Cell: ({ row }) => {
          const item = row.original
          const count = item.ProductListCount || 0

          return (
            <div className="quick-list-products-count">
              <b className={count ? 'text-success' : 'text-danger'}>{count}</b>
              <button
                onClick={() => onViewProducts(item)}
                disabled={!count}
                data-testid={`btn-view-products-${item.ProductCustomListId}`}>
                <FontAwesomeIcon
                  icon={faEye}
                  style={{
                    color: count ? '#11D29E' : '#c4c4c4',
                    fontSize: '1.8rem',
                  }}
                />
              </button>
            </div>
          )
        },
      },
      {
        Header: t('QUICK_LIST_SETTINGS.LIST.STATUS'),
        accessor: 'Status',
        Cell: ({ value }) => {
          const isActive = isActiveStatus(value)
          const statusLabel = isActive
            ? t('QUICK_LIST_SETTINGS.FORM.ACTIVE')
            : t('QUICK_LIST_SETTINGS.FORM.INACTIVE')

          return (
            <span
              aria-label={statusLabel}
              title={statusLabel}
              className={
                isActive
                  ? 'quick-list-status-active'
                  : 'quick-list-status-inactive'
              }>
              <FontAwesomeIcon icon={isActive ? faCheck : faTimes} />
            </span>
          )
        },
      },
      {
        Header: t('QUICK_LIST_SETTINGS.LIST.ACTIONS'),
        accessor: 'actions',
        Cell: ({ row }) => (
          <div className="quick-list-actions">
            <button
              type="button"
              className="quick-list-action quick-list-action--edit"
              onClick={() => onEdit(row.original)}
              title={t('QUICK_LIST_SETTINGS.LIST.EDIT')}
              aria-label={t('QUICK_LIST_SETTINGS.LIST.EDIT')}
              data-testid={`btn-edit-${row.original.ProductCustomListId}`}>
              <FontAwesomeIcon icon={faSquarePen} />
            </button>
            <button
              type="button"
              className="quick-list-action quick-list-action--catalog"
              onClick={() => onGenerateCatalog(row.original)}
              title={t('QUICK_LIST_SETTINGS.LIST.GENERATE_CATALOG')}
              aria-label={t('QUICK_LIST_SETTINGS.LIST.GENERATE_CATALOG')}
              data-testid={`btn-generate-catalog-${row.original.ProductCustomListId}`}>
              {/* viewBox recortado al dibujo para que ocupe la caja de 16px como los demás */}
              <CatalogIcon
                viewBox="5.5 3.5 14 17"
                aria-hidden="true"
                focusable="false"
              />
            </button>
            <button
              type="button"
              className="quick-list-action quick-list-action--delete"
              onClick={() => onDelete(row.original)}
              title={t('QUICK_LIST_SETTINGS.LIST.DELETE')}
              aria-label={t('QUICK_LIST_SETTINGS.LIST.DELETE')}
              data-testid={`btn-delete-${row.original.ProductCustomListId}`}>
              <FontAwesomeIcon icon={faTrashAlt} />
            </button>
          </div>
        ),
      },
    ],
    [
      onViewProducts,
      onEdit,
      onDelete,
      onGenerateCatalog,
      pagination.currentPage,
      pagination.pageSize,
    ]
  )
}

export default useColumnSearchQuickList
